// "Alex Morgan" -> "AM"; falls back to the first two letters of the email.
export const initialsOf = (name, email) => {
  const source = (name || email || "?").trim();
  const parts = source.split(/\s+/).filter(Boolean);
  const letters =
    parts.length > 1 ? parts[0][0] + parts[parts.length - 1][0] : source.slice(0, 2);
  return letters.toUpperCase();
};

export const firstNameOf = (name, email) =>
  (name || "").trim().split(/\s+/)[0] || (email || "").split("@")[0];
